import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";

//Components
import Loading from "../../../components/Loading/Loading";
import MainCard from "../../../components/MainCard/MainCard";
import TextField from "../../../components/TextField/TextField";

import { showMessage } from "../../../helpers/message";

//Api
import relatorio_api from "../../../api/relatorio_api";
import geradoresCategoria_api from "../../../api/geradoresCategoria_api";
import RelatorioGeradoresSemContratoFirmado from "./RelatorioGeradoresSemContratoFirmado";
import FiltroPrefeitura from "views/Shared/FiltroPrefeitura";

function initialStateFiltros() {
  return {
    cpfcnpj: "",
    prefeitura_Id: "",
    categoriaId: null,
    categoriaId_selected: { value: null, label: "Todos" },
    dataInicial: "",
    dataFinal: "",
    nomeRelatorio: "Relatórios - Geradores sem contrato firmado",
  };
}

export default function GeradoresSemContratoFirmado() {
  //Variavel utilizada para navegação
  const navigate = useNavigate();

  //Estado de controle do loading na tela
  const [loading, setLoading] = useState(false);

  //Estado de controle dos valores dos filtros
  const [filtros, setFiltros] = useState(initialStateFiltros());

  //Estado que guarda os dados do relatorio
  const [dadosRelatorio, setDadosRelatorio] = useState([]);

  const [prefeitura_Id, setPrefeitura_Id] = useState(null);

  //Estado que guarda as opções das categorias de gerador
  const [optionsCategorias, setOptionsCategorias] = useState([]);

  //Change para os campos de data
  const onChangeFiltros = (e) => {
    const { name, value } = e.target;
    setFiltros({
      ...filtros,
      [name]: value,
    });
  };

  //Change para o select de categoria — CategoriaId precisa ir null (não 0) quando "Todos" pra não filtrar por engano no backend
  const onChangeCategoria = (e) => {
    setFiltros({
      ...filtros,
      categoriaId_selected: e,
      categoriaId: e && e.value ? e.value : null,
    });
  };

  //Função que carrega a lista de categorias de gerador ativas
  const loadCategorias = () => {
    geradoresCategoria_api
      .GetListAtivos()
      .then((response) => {
        const _categorias = response.data.map((value) => {
          return { value: value.id, label: value.descricao };
        });
        setOptionsCategorias([{ value: null, label: "Todos" }, ..._categorias]);
      })
      .catch((e) => showMessage("Aviso!", e.message, "error"));
  };

  //Função que puxa os dados do relatorio
  const carregarRelatorio = (prefeitura_Id) => {
    const _filtros = {
      ...filtros,
      prefeitura_Id,
      dataInicial: filtros.dataInicial || null,
      dataFinal: filtros.dataFinal || null,
    };

    setLoading(true);
    relatorio_api
      .RelatorioGeradoresSemContratoFirmado(_filtros)
      .then((response) => {
        setDadosRelatorio(response.data);
      })
      .catch((e) => showMessage("Aviso", e.message, "error", null))
      .finally((f) => setLoading(false));
  };

  const handlePrefeitura = (value) => {
    setPrefeitura_Id(value);
    loadCategorias();
  };

  if (dadosRelatorio.length > 0) {
    return (
      <RelatorioGeradoresSemContratoFirmado
        dadosRelatorio={dadosRelatorio}
        btnVoltar={() => setDadosRelatorio([])}
        filtros={filtros}
      />
    );
  }

  return (
    <MainCard btnVoltarInTop={() => navigate(-1)}>
      {loading && <Loading />}
      <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
      {prefeitura_Id &&
        <Row sm="12" md="6" lg="4">
          <Col sm="12" md="6" lg="4">
            <TextField
              placeholder='Selecione'
              label={"Categoria"}
              type={"select"}
              searchable
              name="categoriaId_selected"
              options={optionsCategorias}
              value={filtros?.categoriaId_selected}
              onChange={onChangeCategoria}
            />
          </Col>
          <Col sm="12" md="6" lg="4">
            <TextField name="dataInicial" label={"Data inicial"} type={"date"} value={filtros.dataInicial} onChange={onChangeFiltros} />
          </Col>
          <Col sm="12" md="6" lg="4">
            <TextField name="dataFinal" label={"Data final"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} />
          </Col>
          <Col sm="12" md="6" lg="3" style={{ marginTop: "1.875rem" }}>
            <Button
              className='w-100 fw-bold'
              color='info text-light'
              onClick={() => carregarRelatorio(prefeitura_Id)}>Gerar Relatório</Button>
          </Col>
        </Row>
      }
    </MainCard>
  );
}
